import BidLabel from '../../../../elements/BidLabel/BidLabel'

const Condition = ({ condition }: { condition: string }) => {
  return (
    <BidLabel
      value={condition}
      theme="blue-dark"
      fontStyles="text-12 md:text-10"
      twcss="px-6 py-1 h-auto"
    />
  )
}

export default Condition
